export const START_CONVERSATION_LABEL = 'Start a conversation';
